import { useEffect } from 'react';
import { createValueStore } from '@sorrem-client/ui/shared/value-store';
import { useValueStoreSelector } from './value-store';

/** How many full-screen moments (a cutscene, a vision) are open right now. */
const coverCount = createValueStore(0);

const isAnyCovering = (count: number): boolean => count > 0;

/**
 * Marks the screen as covered while the calling component is mounted, so UI
 * that floats over the page (first-time callouts) steps aside until it ends.
 * For full-screen moments like a cutscene or a vision.
 */
export function useCoversScreen(): void {
    useEffect(() => {
        coverCount.set((count) => count + 1);
        return (): void => coverCount.set((count) => count - 1);
    }, []);
}

/** Whether a full-screen moment covers the screen (see `useCoversScreen`). */
export function useIsScreenCovered(): boolean {
    return useValueStoreSelector(coverCount, isAnyCovering);
}
